import { motion } from "framer-motion";
import { MapPin } from "lucide-react";
import Field from "@/components/booking/Field";
import AcTypeSelector from "@/components/booking/AcTypeSelector";
import { STEP_MOTION } from "@/lib/motion-presets";

export default function BookingStep2({ t, form, set, errors }) {
  return (
    <motion.div key="s2" {...STEP_MOTION} className="space-y-5">
      <Field
        icon={<MapPin className="w-4 h-4" />}
        label={t.booking.fields.address}
        error={errors.address}
      >
        <input
          data-testid="booking-address-input"
          className={`input-field ${errors.address ? "error" : ""}`}
          value={form.address}
          onChange={(e) => set("address", e.target.value)}
          placeholder="Pl. Bagolyvár u. 12, Balatonszemes"
        />
      </Field>

      <AcTypeSelector
        label={t.booking.fields.acType}
        value={form.ac_type}
        options={t.booking.acTypes}
        onChange={(v) => set("ac_type", v)}
      />

      <div className="grid grid-cols-2 gap-5">
        <Field label={t.booking.fields.units}>
          <input
            data-testid="booking-units-input"
            type="number"
            min={1}
            max={20}
            className="input-field"
            value={form.units_count}
            onChange={(e) => set("units_count", e.target.value)}
          />
        </Field>
      </div>
    </motion.div>
  );
}
